import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import './index.scss';

const template = ({ props, options }) => html`
    <button type="button" class="menuBtn" ?open=${props.open} data-ui="menu-btn" @click="${options.handlerClick}">
        <i class="menuBtn__burger">
            <span></span>
            <span></span>
        </i>
    </button>
`;

@componentMixin(DomComponentMixin)
class MenuButton extends Component {
    options = {
        template,
    };

    props = {};

    async onSetup() {}

    onOpen() {
        this.el.style.setProperty('--delay-open', 0);
    }
    offOpen() {
        this.el.style.setProperty('--delay-open', '0.5s');
    }
}

export default MenuButton;
